export default __webpack_public_path__ + "static/hannah-barker-8b9dd960cbbda63dba2790c1e0906b1e.png";